exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n    font-size: 13px;\n    margin-bottom: 0;\n}", ""]);

// exports
